var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.responseDetails)?_c('div',[_c('p',[_vm._v("I'm the details")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }